var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7793 2.7832V5.62695L8.2168 7.07422L7.81055 7.75977L4.9668 6.0332V2.7832H5.7793ZM2.42773 8.57227C3.29102 9.41862 4.3151 9.8418 5.5 9.8418C6.6849 9.8418 7.70052 9.41862 8.54688 8.57227C9.41016 7.70898 9.8418 6.6849 9.8418 5.5C9.8418 4.3151 9.41016 3.29948 8.54688 2.45312C7.70052 1.58984 6.6849 1.1582 5.5 1.1582C4.3151 1.1582 3.29102 1.58984 2.42773 2.45312C1.58138 3.29948 1.1582 4.3151 1.1582 5.5C1.1582 6.6849 1.58138 7.70898 2.42773 8.57227ZM1.66602 1.69141C2.73242 0.625 4.01042 0.0917969 5.5 0.0917969C6.98958 0.0917969 8.25911 0.625 9.30859 1.69141C10.375 2.74089 10.9082 4.01042 10.9082 5.5C10.9082 6.98958 10.375 8.26758 9.30859 9.33398C8.25911 10.3835 6.98958 10.9082 5.5 10.9082C4.01042 10.9082 2.73242 10.3835 1.66602 9.33398C0.616536 8.26758 0.0917969 6.98958 0.0917969 5.5C0.0917969 4.01042 0.616536 2.74089 1.66602 1.69141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/access_time.308615ea4e54448ba8702a2498ec5af6.svg";
export { ForwardRef as ReactComponent };